// @flow
import { compose } from 'recompose';
import { connect } from 'react-redux';

import Headset from './Headset';

export default compose(
  connect(
    state => ({}),
    dispatch => ({}),
  ),
)(Headset);
